import { Spacing } from '@persona-id/design-tokens';
import { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';

export interface MatchHighlightProps extends Omit<ComponentPropsWithoutRef<'p'>, 'color'> {
  matchStrength?: 'none' | 'partial' | 'full';
}

export const MatchHighlight = styled.span<MatchHighlightProps>`
  /* Sizing and Borders */
  width: fit-content;
  padding-left: ${Spacing[1]};
  padding-right: ${Spacing[1]};
  border-radius: ${Spacing[1]};

  /* Allow background colors to be dictated by the matchStrength. */
  background-color: ${({ matchStrength, theme }) => {
    switch (matchStrength) {
      case 'none':
        return theme.color.background.disabled;
      case 'partial':
        return theme.color.variants.success.highlightLight;
      case 'full':
        return theme.color.variants.success.highlightDark;

      default:
        return 'none';
    }
  }};
`;

export default MatchHighlight;
